window.init_matter = function () {
    jQuery(".js-form-data.filing_date").off("change");
    jQuery(".file_uploads").off("change");
    jQuery(".js-save-folder").off("click");

    jQuery(".js-form-data.filing_date").change(function () {
        let val = jQuery(this).val();
        let year_t = val.substring(0, 4); //ex: 2021
        let year = parseInt(year_t);
        let period_priority = val.replace(year_t, year + 1);
        let period_req_examination = val.replace(year_t, year + 3);
        jQuery(".js-form-data.period_priority").val(period_priority);
        jQuery(".js-form-data.period_req_examination").val(
            period_req_examination
        );
    });
    jQuery(".file_uploads").change(function () {
        let id = jQuery(this).attr("data-id");
        console.log("data-id is " + id);
        let attr = jQuery(this).attr("data-attr");
        let parent = jQuery(this).parent();
        parent.addClass("loading");

        let file = jQuery(this);
        let fd = new FormData();
        fd.append("file", file.prop("files")[0]);
        fd.append("relation_col", attr);
        fd.append("relation_id", id);
        post_upload_folder_file(fd)
            .done(function (data) {
                jQuery(".js-form-data[data-attr='" + attr + "']").val(
                    data["file_id"]
                );
                toastr["success"](
                    "ファイルをアップロードしました。変更を反映するには保存を押してください"
                );
                parent.removeClass("loading");
            })
            .fail(function (xhr, textStatus, errorThrown) {
                let data = {}
                try {
                    data = $.parseJSON(xhr.responseText);
                    if (data['code'] == 507) {
                        toastr["error"](
                            "ファイルアップロードに失敗しました。案件の容量制限を超えています。プランをアップグレードしてください。"
                        );
                    } else {
                        toastr["error"](
                            "ファイルアップロードに失敗しました。１ファイルのアップロード容量を超えている可能性があります。"
                        );
                    }
                } catch (e) { }
                parent.removeClass("loading");
            });
    });
    jQuery(".js-save-folder").click(function () {
        let id = jQuery(this).attr("data-id");

        if (jQuery("#open_tab").attr("data-allable") != "1") {
            toastr["error"]("変更ボタンを押してください。");
            return;
        }
        // 表示を無効化するロジックをcompleteにも追加しておく
        jQuery("#open_" + id + " .delete-button").attr("disabled", true);
        jQuery("#open_" + id).attr("data-allable", "0");
        jQuery("#open_" + id + " textarea").attr("readonly", true);
        jQuery("#open_" + id + " select").attr("disabled", true);

        let dom = jQuery("#open_tab");
        let folder = new Folder(id);
        let fd = {};

        fd["error"] = 0;
        dom.find(".js-form-data").each(function () {
            fd[jQuery(this).attr("data-attr")] = jQuery(this).val();

            if (
                jQuery(this).attr("data-attr") == "reference_number" &&
                !jQuery(this).val()
            ) {
                toastr["error"]("整理番号を入力してください。");
                /*fd["error"] = 1;*/
            }
            if (
                jQuery(this).attr("data-attr") == "country" &&
                (!jQuery(this).val() || jQuery(this).val() == "")
            ) {
                toastr["error"]("国・地域を入力してください。");
                /*fd["error"] = 1;*/
            }
        });

        if (fd["error"] == 0) {
            dom.find(".circular.ui.blue.icon.button").each(function () {
                jQuery(this).trigger("click");
            });
            folder.update(id, fd);
            toastr["success"]("案件データを保存しました");

        }
        //TODO:2023/12/20
        //情報更新後にページがリロードされる機能がオミットされているけどOK？
        // toastr["info"]("自動的にページが更新されるまでお待ちください..。");
        // setTimeout(function () {
        //     location.href = location.href.replace("create=true", "");
        // }, 5000);
        // toastr["success"]("");
        // 保存が完了したらページ更新するようにする？
        // location.reload();
    });

}

jQuery(document).ready(function () {
    window.init_matter();
});
